import { Button } from "../../../../shadcn/components/ui/button";
import CustomModalLayoutV2 from "../../../bidder/Tabs/auctionFloor/components/CustomModalLayoutV2";

interface PDDownloadAllSuccessModalPropsInterface {
  openDownloadAllAsZipSuccess: boolean;
  setOpenDownloadAllAsZipSuccess: (value: boolean) => void;
  onClose: () => void;
  onWhatsAppButtonClick?: () => void;
  whatsAppButtonStates?: {
    processing: boolean;
    success: boolean;
    error: boolean;
  };
}

export const PDDownloadAllSuccessModal: React.FC<
  PDDownloadAllSuccessModalPropsInterface
> = ({
  openDownloadAllAsZipSuccess,
  setOpenDownloadAllAsZipSuccess = () => {},
  onClose = () => {},
  onWhatsAppButtonClick = () => {},
  whatsAppButtonStates = {
    processing: false,
    success: false,
    error: false,
  },
}) => {
  return (
    <CustomModalLayoutV2
      open={openDownloadAllAsZipSuccess}
      blurBackground={true}
      onClose={() => {
        onClose();
        setOpenDownloadAllAsZipSuccess(false);
      }}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[400px] overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <p className="my-2 font-openSans text-[#717272] text-sm">
        All Documents has been saved to your device/system.
      </p>

      <Button
        onClick={() => {
          onWhatsAppButtonClick();
        }}
        disabled={
          whatsAppButtonStates?.processing || whatsAppButtonStates?.success
        }
        className={`bg-white inline-flex items-center gap-2 border border-[#f26c1f] text-brand-primaryAction px-4 py-2 rounded-full text-[0.85rem] font-medium hover:bg-[#f26c1f] hover:text-white transition-colors ${
          whatsAppButtonStates?.success
            ? "bg-brand-primaryAction text-white"
            : ""
        }`}
      >
        {whatsAppButtonStates?.success
          ? "✔ Sent All Documents to WhatsApp"
          : whatsAppButtonStates?.processing
          ? "Sending All Documents to WhatsApp..."
          : `Send All Documents to WhatsApp`}
      </Button>

      {whatsAppButtonStates?.error && (
        <div className="text-red-500 text-sm mt-2">
          ❌ Error sending documents to WhatsApp
        </div>
      )}
    </CustomModalLayoutV2>
  );
};
